import { render, staticRenderFns } from "./PreAndPostStockField.vue?vue&type=template&id=73ca2ff4&scoped=true"
import script from "./PreAndPostStockField.vue?vue&type=script&lang=js"
export * from "./PreAndPostStockField.vue?vue&type=script&lang=js"
import style0 from "./PreAndPostStockField.vue?vue&type=style&index=0&id=73ca2ff4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73ca2ff4",
  null
  
)

export default component.exports